import Axios from 'axios';
import { ConfigRuntime } from 'configRuntime';

export const axiosInstance = Axios.create({
  baseURL: ConfigRuntime.backendUrl,
  responseType: 'json',
});
